// AjaxController.js
class AjaxController {
    
    /**
     * 
     * @param {string} baseURL 
     */
    constructor(baseURL, noAuthCallback = null) {
      this.baseURL = baseURL;
      this.noAuthCallback = noAuthCallback;
    }
  

    /**
     * 
     * @param {*} endpoint 
     * @returns 
     */
    async get(endpoint) {
      const retval = this.request(endpoint, 'GET');
      if (retval?.loggedIn === false) {
        this.noAuthCallback();
      }
      return retval;
    }
  

    /**
     * 
     * @param {*} endpoint 
     * @param {*} data 
     * @returns 
     */
    async post(endpoint, data) {
      const retval = this.request(endpoint, 'POST', data);
      if (retval?.loggedIn === false) {
        this.noAuthCallback();
      }
      return retval;
    }
  


    /**
     * 
     * @param {*} endpoint 
     * @param {*} data 
     * @returns 
     */
    async put(endpoint, data) {
      const retval = this.request(endpoint, 'PUT', data);
      if (retval?.loggedIn === false) {
        this.noAuthCallback();
      }
      return retval;
    }


  
    /**
     * 
     * @param {*} endpoint 
     * @returns 
     */
    async delete(endpoint) {
      const retval = this.request(endpoint, 'DELETE');
      if (retval?.loggedIn === false) {
        this.noAuthCallback();
      }
      return retval;
    }
  


    /**
     * 
     * @param {*} endpoint 
     * @param {*} method 
     * @param {*} data 
     * @returns 
     */
    async request(endpoint, method, data = null) {
      const url = `${this.baseURL}${endpoint}`;
      const options = {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // WICHTIG: Damit das Cookie gespeichert wird
      };
  
      if (data) {
        options.body = JSON.stringify(data);
      }  
      try {
        const response = await fetch(url, options);
        if (!response.ok) {
          if (response.status === 403) {
            this.noAuthCallback();
          }
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return await response.json();
      } catch (error) {
        console.error('Ajax request failed:', error);
        throw error;
      }
    }
  }
  
  export default AjaxController;